<template>
  <q-btn
    flat
    no-caps
    padding="3px 8px 0"
    :disable="isDisabled"
    class="col-auto tw-rounded-full tw-transition hover:tw-bg-primary/10"
    data-testid="gravador-abrir"
    @click="openRecordModal"
  >
    <label class="cursor-pointer">
      <RecordVoiceIcon />
      <q-tooltip content-style="font-size: 12px; padding: 4px 8px; border-radius: 4px;">Gravar Áudio</q-tooltip>
    </label>
  </q-btn>
</template>

<script>
import { mapActions } from 'vuex'
import RecordVoiceIcon from '@/assets/icons/recordVoice.svg'
import RecorderVoiceModal from './player/RecorderVoiceModal'

export default {
  components: {
    RecordVoiceIcon
  },

  props: {
    refId: {},
    refType: {},
    isDisabled: { default: false }
  },

  methods: {
    ...mapActions({
      startUpload: 'uploadModule/startUpload'
    }),

    openRecordModal () {
      const vm = this

      vm.$q.dialog({
        parent: vm,
        component: RecorderVoiceModal
      }).onOk(vm.onAudio)
    },

    onAudio (audio) {
      this.startUpload({
        refId: this.refId,
        refType: this.refType,
        files: [audio]
      })
    }
  }
}

</script>
